import { Component } from '@angular/core';

@Component({
  selector: 'cx-store-finder-header',
  templateUrl: './store-finder-header.component.html',
  styleUrls: ['./store-finder-header.component.scss']
})
export class StoreFinderHeaderComponent {}
